<ng-container *ngIf="(layerStore.activeLayer | async) as activeLayer">
  <div class="popup-container" [ngClass]="data.type === HOVER_POPUP ? 'hover-popup' : ''" *ngIf="(layerStore.activeLevel | async) as activeLevel" [attr.data-cy]="'mapPopup'">
    <button app-icon-button iconSize="15px" class="close-button" [attr.data-cy]="'close-popup-button'" (click)="handleClose()" *ngIf="data.type !== HOVER_POPUP">
      <app-icon svgIcon="cancel"></app-icon>
    </button>

    <button app-icon-button iconSize="17px" class="drag-button" [attr.data-cy]="'drag-button'">
      <app-icon svgIcon="drag"></app-icon>
    </button>

    <div class="list-wrapper" [ngClass]="data.type === DEFAULT_POPUP ? 'list-wrapper--grouped' : ''">
    <ng-container [ngSwitch]="data.type">
      <app-grouped-popup-list *ngSwitchCase="DEFAULT_POPUP"
                              [title]="popupService.popupTitle"
                              [properties]="$any(data).properties"
                              [activeLayer]="activeLayer"
                              [activeLevel]="activeLevel"
                              [isLoading]="!!(colorScaleService.isBeingLoaded | async)"
                              (unlockRequested)="handleUnlockRequest($event)"
      >
      </app-grouped-popup-list>

      <app-layers-popup-list
      *ngSwitchCase="HOVER_POPUP"
      [title]="$any(data).properties.name ?? (layerStore.activeLevel.value === H3_RES5_LEVEL_LAYER ? 'Cell (5 mile)' : 'Cell (1 mile)')"
      [properties]="$any(data).properties | sortProperties"
      [activeLayer]="activeLayer"
      [activeLevel]="activeLevel"
      [isHoverPopup]="true"
      >
      </app-layers-popup-list>

      <app-schools-popup-list *ngSwitchCase="SCHOOLS_POPUP"
                              [properties]="$any(data).properties"
                              [isSeeMoreActive]="popupService.isSeeMoreActive"
      >
      </app-schools-popup-list>

      <app-ori-popup-list *ngSwitchCase="ORI_POPUP"
                          [properties]="$any(data).properties"
                          [isSeeMoreActive]="popupService.isSeeMoreActive"
      ></app-ori-popup-list>
    </ng-container>
    </div>
    <!-- The grouped list collapses itself; only the schools/ORI lists still
         need an all-or-nothing toggle. -->
    <button class="toggle-data-count" (click)="toggleSeeMore()" *ngIf="data.type === SCHOOLS_POPUP || data.type === ORI_POPUP">
      {{ popupService.isSeeMoreActive ? 'Hide' : 'See more' }}
    </button>

    <div class="popup-tools" *ngIf="data.type === DEFAULT_POPUP">
      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        *ngIf="accessService.getIsAdmin()"
        (click)="handleDownloadXlsx()"
        [matTooltip]="'Download data (xlsx)'">
        <app-icon svgIcon="download"></app-icon>
      </button>

      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        (click)="handleShare()"
        [matTooltip]="'Share location link'">
        <app-icon svgIcon="share"></app-icon>
      </button>

      <div class="cta-group">
        <button
          (click)="handleOrderReport()"
          class="secondary-button"
          [matTooltip]="'Order a full report for this location'"
          app-icon-button
          iconSize="14px"
        >
          Order report
          <app-icon svgIcon="report"></app-icon>
        </button>

        <button
          (click)="goToSalesForecast()"
          class="secondary-button"
          [matTooltip]="'Is this a good location for your business?'"
          app-icon-button
          iconSize="14px"
        >
          Forecast Sales
          <app-icon svgIcon="site-selection"></app-icon>
        </button>
      </div>
    </div>

    <!-- The padlocks in the list above are the whole pitch, so the answer to
         them gets a row of its own rather than a third slot in the tool strip,
         and is drawn in the same blue-to-violet those locked rows carry. A
         subscriber already has it; the two secondary CTAs are what is still
         worth selling them. -->
    <button
      type="button"
      class="full-access-cta"
      *ngIf="
        data.type === DEFAULT_POPUP && !(accessService.isPaidPlanActive | async)
      "
      (click)="handleGetFullAccess()"
      [attr.data-cy]="'popup-full-access'"
    >
      <span class="full-access-cta__text">
        <span class="full-access-cta__title">Know America Like It’s Your Own</span>
        <span class="full-access-cta__sub">Full data on any US neighborhood, plus reports, AI, the compare tool, and more.</span>
      </span>
      <app-icon class="full-access-cta__arrow" svgIcon="arrowForward"></app-icon>
    </button>
  </div>
</ng-container>
